import { formatINR } from '../../utils/formatters';
import { StatusBadge } from '../ui/StatusBadge';

export function RecentTransactions({ transactions }) {
  const rows = (transactions || []).slice(0, 10);

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-800">Recent transactions (synced)</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-xs uppercase text-slate-500">
              <th className="pb-2 pr-2">Date</th>
              <th className="pb-2 pr-2">Narration</th>
              <th className="pb-2 pr-2">Ledger</th>
              <th className="pb-2 pr-2">Status</th>
              <th className="pb-2 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="py-2 pr-2 font-mono text-xs text-slate-600">{t.date}</td>
                <td className="py-2 pr-2 text-slate-800">{t.narration}</td>
                <td className="py-2 pr-2 text-slate-600">{t.ledger}</td>
                <td className="py-2 pr-2">
                  <StatusBadge status={t.status} />
                </td>
                <td className="py-2 text-right font-mono font-medium text-slate-900">
                  {t.debit > 0 ? `+${formatINR(t.debit)}` : `−${formatINR(t.credit)}`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
